import { Component, ElementRef, Input, OnChanges, ViewChild} from '@angular/core';
import Chart from 'chart.js/auto'
import {PulseReportChartData} from '../../../../core/types/chart.types';
import {JsonPipe} from '@angular/common';

@Component({
  selector: 'app-bar-chart',
  standalone: true,
  imports: [
    JsonPipe
  ],
  templateUrl: './bar-chart.component.html',
  styleUrl: './bar-chart.component.scss'
})
export class BarChartComponent implements OnChanges {
  @ViewChild('barChart') barCharElement!: ElementRef;
  @Input({required: true}) pulseReportChartData!: PulseReportChartData;

  public ngOnChanges() {
    if (!this.barCharElement) { return; }

    new Chart(
      this.barCharElement.nativeElement,
      {
        type: 'bar',
        options: {
          plugins: {
            legend: {
              display: true
            },
            tooltip: {
              enabled: true
            }
          }
        },
        data: {
          labels: this.pulseReportChartData.map(row => row.managerName),
          datasets: [
            {
              label: 'План',
              borderRadius: 10,
              backgroundColor: 'rgba(63, 81, 181, .8)',
              data: this.pulseReportChartData.map(row => row.plan)
            },
            {
              label: 'Факт',
              borderRadius: 10,
              backgroundColor: 'rgba(76, 175, 80, .8)',
              data: this.pulseReportChartData.map(row => row.fact)
            }
          ]
        }
      }
    )
  }

}
